import { FC, ReactNode } from "react";
import { mergeClassNames } from "../../../../helpers";
import { Styled } from "../../types";
import { BadgeTypes } from "./types";

type BadgeStyles = {
  [key in BadgeTypes]: { wrapper: string; title: string };
};

export const typeClassNames: BadgeStyles = {
  neutral: {
    wrapper: "bg-stone-100 dark:bg-stone-900 dark:border-stone-900",
    title: "text-stone-700 dark:text-stone-200",
  },
  warning: {
    wrapper: "bg-yellow-100 dark:bg-yellow-900 dark:border-yellow-800",
    title: "text-yellow-700 dark:text-yellow-200",
  },
  success: {
    wrapper: "bg-green-100 dark:bg-green-900 dark:border-green-800",
    title: "text-green-600 dark:text-green-200",
  },
  error: {
    wrapper: "bg-red-100 dark:bg-red-900 dark:border-red-800",
    title: "text-red-600 dark:text-red-200",
  },
};

type BadgeProps = {
  type: keyof typeof typeClassNames;
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  isStateBadge?: boolean;
};

export const Badge: FC<React.PropsWithChildren<Styled & BadgeProps>> = ({
  type,
  title,
  subtitle = "",
  icon,
  className = "",
  isStateBadge,
}) => {
  const wrapperClass = mergeClassNames(
    "max-w-fit",
    typeClassNames[type].wrapper,
    "flex items-center",
    subtitle?.length ? "gap-2" : "",
    isStateBadge
      ? "px-2.5 py-0.5 text-sm rounded-full font-medium"
      : "px-2 py-1 text-xs dark:border rounded-lg",
    className,
  );

  return (
    <div className={wrapperClass}>
      {icon || null}
      <span className={`${typeClassNames[type].title} my-auto`}>{title}</span>
      {subtitle && (
        <p className="w-fit border-l border-stone-300 pl-2 text-stone-500 dark:border-stone-700 dark:text-stone-400">
          {subtitle}
        </p>
      )}
    </div>
  );
};
